import { render, staticRenderFns } from "./AddNutritionDrugPrescription.vue?vue&type=template&id=38e13ce8&scoped=true"
import script from "./AddNutritionDrugPrescription.vue?vue&type=script&lang=js"
export * from "./AddNutritionDrugPrescription.vue?vue&type=script&lang=js"
import style0 from "./AddNutritionDrugPrescription.vue?vue&type=style&index=0&id=38e13ce8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e13ce8",
  null
  
)

export default component.exports